import { render } from "./MatrixBoardItem.vue?vue&type=template&id=e7879e94&scoped=true"
import script from "./MatrixBoardItem.vue?vue&type=script&lang=js"
export * from "./MatrixBoardItem.vue?vue&type=script&lang=js"

import "./MatrixBoardItem.vue?vue&type=style&index=0&id=e7879e94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7879e94"]])

export default __exports__